export default "__VITE_ASSET__89LmLCM8__"